:host {
  display: block;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--av-card-separator-color);
}

input {
  @include form-input;
}

.form-field {
  @include form-field;
}

.form-field-horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.actions {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
  &.actions-disclaimer {
    justify-content: space-between;
  }
}

.form-field-phone {
  display: flex;
  flex-direction: row;
  margin-top: 12px;

  av-select-country-dial-code {
    border-bottom: 1px solid var(--av-card-separator-color);
    // margin-right: 8px;
  }
}

.text-muted {
  opacity: 0.5;
}

.av-direction {
  direction: var(--av-direction);
}
